const { postEvent } = require("./event");

function mappedValuesToArray(mapString) {
    return mapString.split(",").map(Number);
}

async function setAbsoluteVolumeDirect(customerId, hubId, zoneId, value, preventEventLog = false) {
    try {
        await postEvent(hubId, customerId, 'SET_ABSOLUTE_VOLUME_DIRECT', { zoneId: zoneId, value: value, preventEventLog: preventEventLog });
    } catch (error) {
        console.log('Could not change zone volume');
    }
}

const [lw, mw, hw] = [40, 60, 80] // change to [20,50,80] when ready
function getMappingConstants(calibrationDecibels) {
    const [lp, mp, hp] = calibrationDecibels;
    const a = (mp - lp) / (mw - lw);
    const b = lp - a * lw;
    const c = (hp - mp) / (hw - mw);
    const d = hp - c * hw;
    return [a, b, c, d];
}

function getMappedVolume(calibrationSysvols, percentValue) {
    var mappedVolume = null;
    if (!calibrationSysvols) {
        calibrationSysvols = [40, 60, 80];
    }

    try {
        const [lp, mp, hp] = calibrationSysvols;
        const [a, b, c, d] = getMappingConstants([lp, mp, hp]);
        if (percentValue > mw) {
            mappedVolume = c * percentValue + d;
        } else if (percentValue > lw) {
            mappedVolume = a * percentValue + b;
        } else {
            mappedVolume = lp / lw * percentValue;
        }

        if (mappedVolume > 100) {
            mappedVolume = 100;
        } else if (mappedVolume < 0 || percentValue <= 0) {
            mappedVolume = 0;
        }
    } catch (err) {
        console.log('Error - missing calibration points', err);
    }
    return mappedVolume;
}

function getReverseMappedVolume(calibrationSysvols, volume) {
    var percentValue = null;
    if (!calibrationSysvols) {
        calibrationSysvols = [40, 60, 80];
    }

    try {
        var [lp, mp, hp] = [40, 60, 80];
        if (calibrationSysvols?.length === 3) {
            [lp, mp, hp] = calibrationSysvols;
        }
        const [a, b, c, d] = getMappingConstants([lp, mp, hp]);

        if (volume > mp) {
            percentValue = (volume - d) / c;
        } else if (volume > lp) {
            percentValue = (volume - b) / a;
        } else {
            percentValue = lw / lp * volume;
        }

        if (percentValue < 0) {
            percentValue = 0;
        }

    } catch (err) {
        console.log('Error - missing calibration points', err);
    }

    return percentValue;
}

function getSystemVolume(wavedvolume, calibrationSysvols) {
    return getMappedVolume(calibrationSysvols, wavedvolume);
}

function getWavedVolume(systemVolume, calibrationSysvols) {
    return getReverseMappedVolume(calibrationSysvols, systemVolume);
}

export {
    mappedValuesToArray,
    setAbsoluteVolumeDirect,
    getMappedVolume,
    getReverseMappedVolume,
    getSystemVolume,
    getWavedVolume
}